<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <span>{{ options.title }}</span>
          </b-col>
          <!-- <b-col cols="12" sm="6" class="mt-2 mt-sm-0">
            <div class="card-header-actions">
              <div style="display: flex; justify-content: space-between">
                <b-button
                  @click="showfilter = !showfilter"
                  :pressed="!showfilter"
                  variant="outline-primary"
                  class="card-header-action mr-1"
                  squared
                  size="sm"
                  title="Show/Hide Filter"
                >
                  <i class="fa fa-filter"></i
                ></b-button>
                <b-form-group size="sm" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="btable_find"
                      placeholder="Find"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        style="width: auto; padding: 0.25rem 0.6rem"
                        variant="outline-primary"
                        :disabled="!btable_find"
                        @click="btable_find = ''"
                      >
                        <i v-if="btable_find" class="fa fa-remove"></i>
                        <i v-if="!btable_find" class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </b-col> -->
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <!-- <b-row no-gutters v-if="showfilter">
              <b-col>
                <b-button
                  @click="showfilter = !showfilter"
                  variant="link"
                  class="card-header-action"
                  squared
                  size="sm"
                >
                  <i class="fa fa-filter pr-2"></i>Filter...</b-button
                >
              </b-col>
            </b-row> -->
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                  <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..." v-model="id"
                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC" :show-count="true"
                    :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']" search-nested>
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Group" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="group" :debounce="options.debounce" placeholder="Group"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!group" @click="group = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <b-row class="px-0 mt-0">
            <b-col cols="auto">
              <b-button-group class="z-0">
                <b-row align-h="start" no-gutters>
                  <b-col class="gridtoolbar" cols="auto" v-for="(tool, index) in tools.filter(
                      (o) => o.position == 'toolbar'
                    )" :key="index">
                    <b-button v-if="tool.type == 'button'" :id="'tool_' + tool.action" :size="tool.size"
                      :variant="tool.variant" :title="tool.title ? tool.title : toolLabel(tool)"
                      :squared="tool.squared ? 'squared' : null" :disabled="toolDisabled(tool.action)"
                      @click="toolClick(tool.action)">
                      <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                      <span v-if="toolLabel(tool)" v-html="toolLabel(tool)">
                      </span>
                      <i v-if="tool.icon2" :class="tool.icon2"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-button-group>
            </b-col>
            <b-col>
              <b-row align-h="end" no-gutters>
                <b-col cols="auto" v-for="(tool, index) in options.view" :key="index">
                  <span v-if="tool.type == 'label'" :class="tool.class">
                    {{ tool.label }}
                  </span>
                  <b-form-radio-group v-if="tool.type == 'radio-group'" :options="tool.options">
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="px-3">
          <b-overlay :show="options.overlay_show" opacity=".9" v-click-outside="outside">
            <div>
              <b-table :dark="$store.state.darkMode" ref="btable" :sticky-header="btable_height + 'px'" striped hover
                small caption-bottom show-empty selectable select-mode="multi" :busy="btable_busy" :items="btable_items"
                :fields="options.fields" :filter="btable_find" @row-selected="btable_rowSelected">
                <template #head(selected)>
                  <i id="selectall" class="ml-1" :class="btable_iconselected()" aria-hidden="true"
                    @click="btable_iconselectedClick()" title="Click to select/unselect all"></i>
                  <b-tooltip target="selectall" triggers="hover" placement="right">Click to select/unselect
                    all</b-tooltip>
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner type="grow" variant="primary" class="align-middle mr-2"></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="btable_icon(slot.item)"></i>
                </template>

                <template v-slot:cell()="row">
                  <div v-if="options.badges &&
                    options.badges.find((obj) => obj.key == row.field.key)
                    ">
                    <span v-html="btable_rowBadgeCell(
                        row.item,
                        options.badges.find(
                          (obj) => obj.key == row.field.key
                        ),
                        options
                      )
                      "></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button variant="link" size="sm" title="Actions" :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')">
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover container="actions-container" triggers="click blur" placement="leftbottom"
                      :target="'popover-target-' + row.item.id">
                      <div>
                        <b-nav vertical>
                          <b-nav-item :title="action.label" v-for="action in btable_rowActionCell(
                                row.item,
                                options
                              )" :key="action.key" @click.stop="btable_rowClick(action.key, row)">
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i :class="btable_rowActionIcon(action, row.item)
                                    "></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button variant="link" size="sm" v-for="action in btable_rowActionCell(row.item, options)"
                      :key="action.key" @click.stop="btable_rowClick(action.key, row)" :title="action.label">
                      <i :class="btable_rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component :is="options.component.name" :selection="btable_selected" :config="cconfig"
                      @discard="toolClick('discard')" @refresh="toolClick('refresh')"></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button v-for="(button, index) in options.overlay.buttons" :key="index"
                      :style="button.style ? button.style : 'width: 80px'" :class="button.class
                          ? button.class
                          : button.dispatch
                            ? null
                            : 'ml-2'
                        " :variant="button.variant
      ? button.variant
      : button.dispatch
        ? 'outline-primary'
        : 'outline-secondary'
    " :size="button.size ? button.size : 'sm'" :squared="button.squared ? button.squared : true"
                      @click="button.dispatch
                          ? toolClick(button.dispatch)
                          : (options.overlay_show = false)
                        ">{{ button.label }}</b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="btable_selected" :config="cconfig" @saveit="saveit"
          @discard="toolClick('discard')" @refresh="toolClick('refresh')"></component>
      </div>

      <b-row v-if="!component" class="excelsheetbuttons px-3">
        <b-col>
          <div v-if="btable_busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
            <span class="small text-primary ml-1">Updating ...</span>
          </div>
          <span v-if="!btable_busy" class="small text-primary">Found {{ btable_items.length }} rows</span>
        </b-col>
      </b-row>
      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button squared size="sm" variant="secondary" @click="$router.go(-1)">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import ZoneChargeEdit from "./Components/ZoneChargeEdit";

export default {
  name: "ZoneCharge",
  components: { ZoneChargeEdit },
  watch: {
    async id() {
      await this.load();
    },
    async group() {
      await this.load();
    },
  },
  data() {
    return {
      group: null,
      id: null,

      options: {
        title: "Zone Charges",
        icon: "fa fa-list",
        debounce: 500,
        tools: [],
        view: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "id",
            label: "SL A/C",
            sortable: true,
          },
          {
            key: "zoneu",
            label: "Zone_U",
            sortable: true,
          },
          {
            key: "zonee",
            label: "Zone_E",
            sortable: true,
          },

          {
            key: "zonel",
            label: "Zone_L",
            sortable: true,
          },
          {
            key: "userpcc",
            label: "UserPCC",
            sortable: true,
          },
          {
            key: "genzoneu",
            label: "GenZone_U",
            sortable: true,
          },
          {
            key: "genzonee",
            label: "GenZone_E",
            sortable: true,
          },

          {
            key: "genzonel",
            label: "GenZone_L",
            sortable: true,
          },
          {
            key: "nongenzoneu",
            label: "NonGenZone_U",
            sortable: true,
          },
          {
            key: "nongenzonee",
            label: "NonGenZone_E",
            sortable: true,
          },

          {
            key: "nongenzonel",
            label: "NonGenZone_L",
            sortable: true,
          },
          {
            key: "group",
            label: "Group",
            sortable: true,
          },
          {
            key: "lcccharge",
            label: "LCC_Charge",
            sortable: true,
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [],
        actions: [
          {
            key: "edit",
            label: "Edit",
            icon: "fa fa-pencil",
            single: true,
            multiple: false,
            component: {
              name: "ZoneChargeEdit",
            },
          },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  async mounted() {
    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.options.actions) {
      if (this.options.fields.some((e) => e.key === "actions")) {
      } else {
        this.options.fields.push({
          key: "actions",
          label: "",
          class: "actions w-140px",
        });
      }
    }
    if (this.user.rolename == "admin") {
      this.options.actions.push({
        key: "deleteit",
        label: "Delete",
        icon: "fa fa-trash text-danger",
        single: true,
        multiple: true,
        overlay: {
          message: "Are you sure you want to delete %group% ?",
          buttons: [
            {
              label: "Yes",
              variant: "danger",
              dispatch: "deleteit",
            },
            {
              label: "No",
              class: "ml-2",
            },
          ],
        },
      });
    }

    this.resizableColumns();

    // Mix common tools with local tools
    this.tools = [...this.tools, ...this.options.tools];
    this.toolRemove("copy,import,archive");
    if (!this.user.rolename == "admin") {
      this.toolRemove("add");
    } else {
      this.toolComponents([
        { action: "add", name: "ZoneChargeEdit" },
        { action: "edit", name: "ZoneChargeEdit" },
      ]);
    }

    //this.loadDDL();
    this.load();
  },

  methods: {
    async load() {
      this.btable_items = [];

      this.btable_busy = true;

      let variables = {
        group: this.group,
        id: this.id,
        zoneu: this.zoneu,
        zonee: this.zonee,
        zonel: this.zonel,
        userpcc: this.userpcc,
        genzoneu: this.genzoneu,
        genzonee: this.genzonee,
        genzonel: this.genzonel,
        nongenzoneu: this.nongenzoneu,
        nongenzonee: this.nongenzonee,
        nongenzonel: this.nongenzonel,
        lcccharge: this.lcccharge,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query zonecharges(
              $id: String
              $zoneu: String
              $zonee: String
              $zonel: String
              $userpcc: String
              $genzoneu: String
              $genzonee: String
              $genzonel: String
              $nongenzoneu: String
              $nongenzonee: String
              $nongenzonel: String
              $group: String
              $lcccharge: String
              $dateformat: String
            ) {
              zonecharges(
                group: $group
                id: $id
                zoneu: $zoneu
                zonee: $zonee
                zonel: $zonel
                userpcc: $userpcc
                genzoneu: $genzoneu
                genzonee: $genzonee
                genzonel: $genzonel
                nongenzoneu: $nongenzoneu
                nongenzonee: $nongenzonee
                nongenzonel: $nongenzonel
                lcccharge: $lcccharge
                dateformat: $dateformat
              ) {
                id
                group
                zoneu
                zonee
                zonel
                userpcc
                genzoneu
                genzonee
                genzonel
                nongenzoneu
                nongenzonee
                nongenzonel

                lcccharge
              }
            }
          `,
          variables,
        });

        this.btable_items = response.data.zonecharges;
      } catch (error) {
        console.log(error);
      }
      this.btable_busy = false;
    },
    async _toolClick(a) {
      console.log("local toolClick: ", a);
      // this.cconfig.find((o) => o.key == "eventcode").value = this.eventcode;
      switch (a) {
        case "delete":
          await this.deleteit();
          break;
      }
      return;
    },
    _toolDisabled(a) {
      console.log("local toolDisabled: ", a);
      switch (a) {
        case "etr":
          return this.btable_selected.length > 0 ? false : true;
        case "email":
          return this.btable_selected.length > 0 ? false : true;
      }
    },

    async deleteit() {
      let variables = {
        rows: this.cleanit(this.btable_selected),
      };
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation deletezonecharges($rows: [Zonecharges_input]) {
              deletezonecharges(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      await this.load();
    },
  },
};
</script>

<style></style>